import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children"];
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { useTypographyClassNames } from './hooks/useTypographyClassNames';
import { TypographyRoot } from './style';
import { typographyDefaultTheme } from './theme';
import { TYPOGRAPHY_CLASS_PREFIX } from './constants';
import { useTypography } from './hooks/useTypography';
export var Typography = forwardRef(function Typography(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(TYPOGRAPHY_CLASS_PREFIX, typographyDefaultTheme);

  var _useTypography = useTypography(props, ref),
      rootProps = _useTypography.rootProps,
      Tag = _useTypography.Tag;

  var classNameComponents = useTypographyClassNames(TYPOGRAPHY_CLASS_PREFIX, className, props);
  return React.createElement(TypographyRoot, Object.assign({}, rootProps, {
    className: classNameComponents.Root,
    theme: theme
  }), function (forwardedProps) {
    return React.createElement(Tag, Object.assign({}, forwardedProps), children);
  });
});
Typography.defaultProps = {
  label: false,
  large: false,
  medium: false,
  pageTitle: false,
  paragraph: false,
  sectionTitle: false,
  small: false,
  subSectionTitle: false
};